/**
 * Model reprezentujący dane Administratora Danych Osobowych (ADO),
 * używane do wygenerowania finalnej treści Obowiązku Informacyjnego dla pacjenta.
 */
export class InformationObligationAnswer {

  /** Pełna nazwa placówki weterynaryjnej (lub firmy będącej właścicielem).
   * Wstawiana w zdaniach typu: "Administratorem Twoich danych osobowych jest [clinicName]...".
   */
  public clinicName: string;

  /** Dokładny adres siedziby kliniki (ulica, numer, kod pocztowy, miasto).
   */
  public clinicAddress: string;

  /** Adres e-mail przeznaczony do kontaktu w sprawach ochrony danych osobowych.
   */
  public clinicEmail: string;

  /** Numer Identyfikacji Podatkowej (NIP) kliniki.
   */
  public clinicTaxId: string;

  /** Numer telefonu kontaktowego do kliniki.
   * Pacjent ma prawo skontaktować się telefonicznie w celu realizacji swoich praw RODO.
   */
  public clinicPhone: string;
}
